import { makeStyles } from '@mui/styles';
import { AppTheme } from '../../../../theme';

export const useStyles = makeStyles((theme: AppTheme) => ({
  modalContainer: {
    height: 400,
    borderWidth: 0,
    backgroundColor: theme.palette.grey[200],
    display: 'flex',
  },
  textContainer: {
    paddingTop: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingBottom: theme.spacing(6),
  },
  description: {
    marginTop: theme.spacing(1),
  }
}));
